import React from 'react';
// Placeholder photo of the work — swap for a real portrait of the vakman later.
import vakmanImg from '../../assets/images/artwer/project-1-balkon-hilversum.jpg';
import vakmanImgWebp from '../../assets/images/artwer/project-1-balkon-hilversum.webp';
import { WhatsAppIcon } from '../../components/artwer/icons';

const WHATSAPP_NUMBER = '31616136942';

export default function TeamTwo() {
  return (
    <section className="team-two">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">De vakman</span>
          </div>
          <h2 className="section-title__title">
            Eén aanspreekpunt,<br /> <span>van begin tot eind</span>
          </h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-4 col-lg-6 col-md-8">
            <div className="team-two__single">
              <div className="team-two__img-box">
                <div className="team-two__img">
                  <picture>
                    <source srcSet={vakmanImgWebp} type="image/webp" />
                    <img src={vakmanImg} alt="Werk van ART-WER: gerenoveerd balkon in Hilversum (foto van de vakman volgt)" width="825" height="1100" loading="lazy" />
                  </picture>
                </div>
              </div>
              <div className="team-two__content">
                <h3 className="team-two__title">
                  <a href="#contact">Uw vaste vakman</a>
                </h3>
                <p className="team-two__sub-title">Eigenaar &amp; uitvoerend — <span className="nowrap">ART-WER</span></p>
                <div className="team-two__social">
                  <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><WhatsAppIcon size={16} /></a>
                  <a href="tel:+31616136942" aria-label="Bellen"><span className="icon-call" aria-hidden="true"></span></a>
                  <a href="mailto:info@art-wer.nl" aria-label="E-mail"><span className="icon-envelope" aria-hidden="true"></span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
